import { useState } from "react";
import Modal from "react-modal";
import useKeypress from "../ownHooks/pressEsc";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";
import { MyModalButtons, MyModalCloseButton, MyModalContentRow, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { MyCancelButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";

var MonitorApi = require('monitor-api');

export default function EvuUpdate({ rowEntry, reloadData, instance }) {
    const [showModal, setShowModal] = useState(false);
    const [inputs, setInputs] = useState({});
    const [update, setUpdate] = useState(new MonitorApi.EisenbahnverkehrsunternehmenUpdate());
    const [upAvailable, setUpAvailable] = useState(false);


    const openModal = event => {
        setInputs({
            evu: rowEntry.original.evu,
            kurz: rowEntry.original.kurz
        });
        setUpdate(pre => ({ ...pre, "evuId": rowEntry.original.id }));
        setShowModal(true);
        setUpAvailable(false);
    }

    const closeModal = () => {
        setUpdate({});
        setShowModal(false);
    }

    useKeypress('Escape', () => {
        closeModal();
    });

    const changeEntry = event => {
        setUpAvailable(true);
        setUpdate(old => ({ ...old, [event.target.id]: event.target.value }));
    }

    const saveChanges = event => {
        event.preventDefault();
        let result = new Promise((resolve) =>
            instance.updateEvuPatch(update, (error, data, response) => {
                if (error) {
                    FehlerauswertungErrResp(error, response);
                    resolve(error);

                } else {
                    alert(`Änderungen gespeichert`);
                    resolve(data);
                }
            }))
        result.then((msg) => {
            closeModal();
            reloadData();
        })
    }
    return (
        <>
            <button onClick={openModal} className="update-bttn">Bearbeiten</button>
            <Modal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={saveChanges}>
                    <h3>Änderungen eintragen:</h3>
                    <MyModalContentRow>
                        <label>Bezeichnung:
                            <MyModalContentTextInput id="evu"
                                onChange={changeEntry}
                                value={update.evu ? update.evu : inputs.evu} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Abkürzung:
                            <MyModalContentTextInput id="kurz"
                                onChange={changeEntry}
                                value={update.kurz ? update.kurz : inputs.kurz} />
                        </label>
                    </MyModalContentRow>
                    <MyModalButtons>
                        <MySaveButton type="submit" disabled={!upAvailable}>Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbrechen</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </Modal>
        </>)
}